import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in category send to rework of review packets procedure */
const SendToReworkScheme = Yup.object().shape({
    reviewedSteps: Yup.array().of(
        Yup.object().shape({
            solicitor: Yup.string().when('isRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().required('Loanwriter need to be added'),
            }),
            datepickerRework: Yup.date().when('isRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.date()
                    .required('Expiry Date need to be filled')
                    .typeError('Expiry Date need to be filled'),
            }),
            isDisplayedEscalatedModal: Yup.bool(),
            isFirstDocument: Yup.bool(),
            isSecondDocument: Yup.bool(),
            isEscalated: Yup.bool(),
            isRework: Yup.bool(),
            firstReason: Yup.string().when('isRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isFirstDocument', {
                    is: (val: boolean) => val === false,
                    then: Yup.string().when('isSecondDocument', {
                        is: (val: boolean) => val === true,
                        then: (schema) => schema,
                        otherwise: Yup.string().required(
                            'Need to choose one document to rework'
                        ),
                    }),
                    otherwise: Yup.string()
                        .required(
                            'Reason message / instruction need to be added'
                        )
                        .test(
                            'space-check',
                            'Reason message / instruction need to be added',
                            (context) =>
                                /^\s+$/i.test(String(context)) === false
                        ),
                }),
            }),
            secondReason: Yup.string().when('isRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isSecondDocument', {
                    is: (val: boolean) => val === false,
                    then: Yup.string().when('isFirstDocument', {
                        is: (val: boolean) => val === true,
                        then: (schema) => schema,
                        otherwise: Yup.string().required(
                            'Need to choose one document to rework'
                        ),
                    }),
                    otherwise: Yup.string()
                        .required(
                            'Reason message / instruction need to be added'
                        )
                        .test(
                            'space-check',
                            'Reason message / instruction need to be added',
                            (context) =>
                                /^\s+$/i.test(String(context)) === false
                        ),
                }),
            }),
            firstReasonPreDefined: Yup.string().when('isRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isFirstDocument', {
                    is: (val: boolean) => val === false,
                    then: Yup.string().when('isSecondDocument', {
                        is: (val: boolean) => val === true,
                        then: (schema) => schema,
                        otherwise: Yup.string().required(
                            'Need to choose one document to rework'
                        ),
                    }),
                    otherwise: Yup.string().required(
                        'Predefined message / instruction need to be added'
                    ),
                }),
            }),
            secondReasonPreDefined: Yup.string().when('isRework', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string().when('isSecondDocument', {
                    is: (val: boolean) => val === false,
                    then: Yup.string().when('isFirstDocument', {
                        is: (val: boolean) => val === true,
                        then: (schema) => schema,
                        otherwise: Yup.string().required(
                            'Need to choose one document to rework'
                        ),
                    }),
                    otherwise: Yup.string().required(
                        'Predefined message / instruction need to be added'
                    ),
                }),
            }),
            escalatedReason: Yup.string().when('isEscalated', {
                is: (val: boolean) => val === false,
                then: (schema) => schema,
                otherwise: Yup.string()
                    .min(
                        8,
                        'Message / Instructions must be 8 characters at minimum!'
                    )
                    .max(
                        256,
                        'Message / Instructions must be 256 characters at maximum!'
                    )
                    .required('Message / Instructions is required'),
            }),
        })
    ),
});

export { SendToReworkScheme };
